const imgWrappers = document.querySelectorAll('.img-swapper-wrapper');

if (imgWrappers.length) {
    imgWrappers.forEach(wrapper => {
        const primaryImage = wrapper.querySelector('.img-swapper .primary');
        const secondaryImage = wrapper.querySelector('.img-swapper .secondary');
        const isStaffBlock = wrapper.closest('.staff');

        if (primaryImage && secondaryImage) {
            if (isStaffBlock) {
                // Dla staff - usuń klasę hidden i ustaw opacity przez CSS
                secondaryImage.classList.remove('hidden');
                
                // Specjalna animacja dla bloku staff
                wrapper.addEventListener('mouseenter', () => {
                    // Secondary image - fade in z lekkim zoom
                    secondaryImage.style.opacity = '1';
                    secondaryImage.style.transform = 'scale(1.03)';
                    
                    // Primary image - lekki zoom bez opacity
                    primaryImage.style.transform = 'scale(1.05)';
                });

                wrapper.addEventListener('mouseleave', () => {
                    // Powrót primary image
                    primaryImage.style.transform = 'scale(1)';
                    
                    // Ukrycie secondary image
                    secondaryImage.style.opacity = '0';
                    secondaryImage.style.transform = 'scale(1)';
                });
            } else {
                // Oryginalna logika dla innych bloków
                wrapper.addEventListener('mouseenter', () => {
                    primaryImage.classList.add('hidden');
                    secondaryImage.classList.remove('hidden');
                });

                wrapper.addEventListener('mouseleave', () => {
                    secondaryImage.classList.add('hidden');
                    primaryImage.classList.remove('hidden');
                });
            }
        }
    });
}